<script>
import functionalFeatureScriptLoaderMixin from "../../mixins/functionalFeatureScriptLoaderMixin";

export default {
  name: "ScriptLoaderGoogleAnalytics",
  mixins: [functionalFeatureScriptLoaderMixin],
  methods: {
    initFunctionalFeatureScript() {
      const script = document.createElement("script");
      script.setAttribute("src", "https://www.google-analytics.com/analytics.js");
      document.head.appendChild(script);
      /* eslint-disable no-undef, prettier/prettier */
      window.ga = window.ga || function() { (ga.q = ga.q || []).push(arguments); }; ga.l = +new Date();
      /* eslint-enable no-undef, prettier/prettier */
    },
  },
};
</script>
